import React, { useEffect, useState, useRef } from "react";
import "./ReceiptScreen.css";
import SelectPopup from "./SelectPopup";
const RECEIPT_API = "http://103.79.74.237:8081/api/receipts";
const INVOICE_API = "http://103.79.74.237:8081/api/receipts/pending";

export default function ReceiptScreen({goHome}) {

  /* ================= STATE ================= */

  const [header, setHeader] = useState({
    receiptNo: "",
    date: new Date().toISOString().slice(0, 10),
    partyName: "",
    partyId: null,
    address: ""
  });

  const [rows, setRows] = useState([]);
  const [receivedAmount, setReceivedAmount] = useState(0);

  const [payment, setPayment] = useState({
    mode: "CASH",
    ref: ""
  });
  const [mobileTab, setMobileTab] = useState("list");
  const [receiptList, setReceiptList] = useState([]);
  const [search, setSearch] = useState("");

  const [showPartyPopup, setShowPartyPopup] = useState(false);
  const [partySearch, setPartySearch] = useState("");
  const [partyList, setPartyList] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
 const [settledParties, setSettledParties] = useState([]);
const [popup,setPopup] = useState({
open:false,
field:"",
title:"",
options:[],
allowAdd:false
});
  const popupRef = useRef(null);
  const receivedRef = useRef(null);
const newBtnRef = useRef(null);
const saveBtnRef = useRef(null);
const exitBtnRef = useRef(null);
const [editReceiptId, setEditReceiptId] = useState(null);
const updateBtnRef = useRef(null);
const [discount, setDiscount] = useState(0);
const [lessApplied, setLessApplied] = useState(false);

const applyLess = () => {
    const remaining = balanceValue; // current balance
    if (remaining <= 0) return;
    setDiscount(remaining);
    setLessApplied(true);
    // Set displayBalance to 0 for all rows
    setRows(prev => prev.map(r => ({ ...r, displayBalance: 0 })));
};
  /* ================= DERIVED (IMPORTANT ORDER) ================= */

const filteredParties = partyList
  .filter(p => !settledParties.includes(p))   // 🔥 NEW
  .filter(p =>
    p.toLowerCase().includes(partySearch.toLowerCase())
  );

  /* ================= INIT ================= */

  useEffect(() => {
    loadNextReceiptNo();
    loadReceiptList();
  }, []);

  /* ================= PARTY POPUP LOAD ================= */

  useEffect(() => {
    if (!showPartyPopup) return;

    fetch(`${RECEIPT_API}/invoice-parties`)
      .then(res => res.json())
      .then(setPartyList);

    setPartySearch("");
    setActiveIndex(0);
  }, [showPartyPopup]);

  /* ================= KEYBOARD NAV ================= */
  const handleActionKeys = (e, current) => {
  if (e.key === "ArrowRight") {
    e.preventDefault();
    if (current === "new") saveBtnRef.current?.focus();
    if (current === "save") exitBtnRef.current?.focus();
  }

  if (e.key === "ArrowLeft") {
    e.preventDefault();
    if (current === "exit") saveBtnRef.current?.focus();
    if (current === "save") newBtnRef.current?.focus();
  }

  if (e.key === "Enter") {
    e.preventDefault();
    if (current === "new") resetForm();
    if (current === "save") handleSave();
    if (current === "exit") goHome();
  }
};

  useEffect(() => {
    if (!showPartyPopup) return;

    const handleKeyDown = e => {
      if (!filteredParties.length) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveIndex(i => (i + 1) % filteredParties.length);
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveIndex(i =>
          i === 0 ? filteredParties.length - 1 : i - 1
        );
      }

      if (e.key === "Enter") {
        e.preventDefault();
        selectParty(filteredParties[activeIndex]);
      }

      if (e.key === "Escape") {
        setShowPartyPopup(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showPartyPopup, activeIndex, filteredParties]);

  useEffect(() => {
  if (!showPartyPopup && header.partyName) {
    setTimeout(() => {
      receivedRef.current?.focus();
    }, 0);
  }
}, [showPartyPopup, header.partyName]);


  /* ================= SELECT PARTY ================= */

  const selectParty = p => {
    setShowPartyPopup(false);

    setHeader(h => ({
      ...h,
      partyName: p,
      address: ""
    }));

    fetch(`${RECEIPT_API}/party-address/${encodeURIComponent(p)}`)
      .then(res => res.text())
      .then(addr => setHeader(h => ({ ...h, address: addr })))
      .catch(() => setHeader(h => ({ ...h, address: "" })));

    loadPendingInvoices(p);
  };

  /* ================= API ================= */

  async function loadNextReceiptNo() {
    const res = await fetch(`${RECEIPT_API}/next-no`);
    const no = await res.json();
    setHeader(h => ({ ...h, receiptNo: no }));
  }

  async function loadReceiptList() {
    const res = await fetch(RECEIPT_API);
    const data = await res.json();
    setReceiptList(Array.isArray(data) ? data : []);
  }
async function loadPendingInvoices(party) {

  const res = await fetch(
    `${RECEIPT_API}/pending-with-advance/${encodeURIComponent(party)}`
  );

  const data = await res.json();

  if (!data.invoices || data.invoices.length === 0) {
    setRows([]);
    return;
  }

  // 🔥 STEP 1: Sort by invoice number descending
  const sorted = [...data.invoices].sort(
    (a, b) => Number(b.invoiceNo) - Number(a.invoiceNo)
  );

  // 🔥 STEP 2: Pick latest invoice
  const latest = sorted[0];

  // 🔥 STEP 3: Set ONLY one row
  setRows([
    {
      invoiceId: latest.id,
      invoiceNo: latest.invoiceNo,
      amount: latest.totalAmount,
      balance: latest.balanceAmount,
      displayBalance: latest.balanceAmount
    }
  ]);
}

  /* ================= DISTRIBUTE ================= */
function distributePayment(value) {
  let remaining = value;
  const updated = rows.map(r => {
    const paid = Math.min(remaining, r.balance);
    remaining -= paid;
    return {
      ...r,
      displayBalance: r.balance - paid
    };
  });
  setRows(updated);
  // remaining here = advance, shown via balanceValue/balanceLabel
}


// 🔥 Correct balance calculation
const totalInvoice = rows.reduce((s, r) => s + r.amount, 0);
const totalInvoiceBalance = rows.reduce((s, r) => s + r.balance, 0);
const totalDisplayBalance = rows.reduce((s, r) => s + r.displayBalance, 0);

// 🔥 Calculate advance (overpayment)
const advance = receivedAmount > 0
  ? Math.max(0, receivedAmount - totalInvoiceBalance)
  : 0;

const balanceValue = advance > 0
  ? advance
  : (receivedAmount > 0 ? totalDisplayBalance : totalInvoiceBalance);

const balanceLabel = advance > 0 ? "ADVANCE" : "BALANCE";



  /* ================= SAVE ================= */

  async function handleSave() {
    if (!header.partyName || receivedAmount <= 0) {
      alert("Select party and enter received amount");
      return;
    }
      // 🔥 NEW FIX — prevent orphan receipt
  if (rows.filter(r => r.invoiceId).length === 0) {
    alert("No pending invoice to apply payment");
    return;
  }
    const payload = {
      receipt: {
        
        receiptDate: header.date,
        partyName: header.partyName,
        partyId: header.partyId,
        paymentMode: payment.mode,
        referenceNo: payment.ref,
        totalReceived: receivedAmount
      },
items: rows
  .filter(r => r.invoiceId)   // 🔥 VERY IMPORTANT FIX
  .map(r => ({
    invoiceId: r.invoiceId,
    invoiceNo: r.invoiceNo
  }))


    };

    const res = await fetch(`${RECEIPT_API}/save`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

   if (!res.ok) {
  const errorText = await res.text();
  console.log("Backend error:", errorText);
  alert("Save failed: " + errorText);
  return;
}


    alert("Receipt saved");
setSearch("");   // 🔥 IMPORTANT
await loadReceiptList();
setShowPartyPopup(false);

    resetForm();
    loadReceiptList();
    loadNextReceiptNo();
  }
async function handleUpdate() {
    if (!editReceiptId) return;

    const payload = {
        receipt: {
            receiptDate: header.date,
            partyName: header.partyName,
            partyId: header.partyId,
            paymentMode: payment.mode,
            referenceNo: payment.ref,
            totalReceived: receivedAmount,
            discountAmount: discount  // 🔥 LESS amount
        },
        items: rows.filter(r => r.invoiceId).map(r => ({
            invoiceId: r.invoiceId,
            invoiceNo: r.invoiceNo
        }))
    };

    const res = await fetch(`${RECEIPT_API}/${editReceiptId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });

    if (!res.ok) {
        alert("Update failed: " + await res.text());
        return;
    }

    alert("Receipt updated");
    resetForm();
    await loadReceiptList();
    await loadNextReceiptNo();
}
  function resetForm() {
    setEditReceiptId(null);
    setDiscount(0);
    setLessApplied(false);
    setHeader({
        receiptNo: null,
        date: new Date().toISOString().slice(0, 10),
        partyName: "",
        partyId: null,
        address: ""
    });
    setRows([]);
    setReceivedAmount(0);
    setPayment({ mode: "CASH", ref: "" });
    setPartySearch("");
    setActiveIndex(0);
    setShowPartyPopup(false);
}
  /* ================= LOAD BY ID ================= */
async function loadReceiptById(id) {
    const res = await fetch(`${RECEIPT_API}/${id}`);
    const data = await res.json();

    setEditReceiptId(id); // 🔥 ADD THIS

    setHeader({
        receiptNo: data.receiptNo,
        partyName: data.partyName,
        date: data.receiptDate,
        address: ""
    });

    setReceivedAmount(data.totalReceived ?? 0);
    setDiscount(data.discountAmount ?? 0); // 🔥 ADD THIS

    const items = data.items || [];
  setRows(items.map(it => ({
    invoiceId: it.invoiceId,
    invoiceNo: it.invoiceNo,
    amount: it.invoiceAmount ?? 0,
    balance: it.invoiceAmount ?? 0,  // 🔥 use full amount as balance for advance calc
    displayBalance: it.balanceAmount ?? 0
})));
}
async function applyAdvance(partyName, invoices) {
  const res = await fetch(
    `${RECEIPT_API}/advance/${encodeURIComponent(partyName)}`
  );
  const advance = await res.json(); // e.g. 88.80

  if (advance <= 0 || invoices.length === 0) return;

  const invoiceTotal = invoices.reduce((s, r) => s + r.amount, 0);

  const adjustedReceived =
    advance >= invoiceTotal
      ? 0
      : invoiceTotal - advance;

  setReceivedAmount(adjustedReceived);
  distributePayment(adjustedReceived);
}

const handlePopupSelect = (val)=>{

if(popup.field==="mode"){
setPayment(p=>({...p,mode:val}));
}

};
  return (
    <div className="rec-root">

      <div className="rec-title">RECEIPT</div>

     <div className={`rec-content ${mobileTab === "entry" ? "show-entry" : "show-list"}`}>

        {/* ================= LEFT ================= */}
        <div className="rec-left">
          <div className="rec-card">

            <div className="rec-card-header">Receipt Entry</div>

            <div className="rec-header">
              <label>Party</label>
              <input value={header.partyName} readOnly onClick={() => setShowPartyPopup(true)} />

              <label>Receipt No</label>
              <input value={header.receiptNo} readOnly />

              <label>Address</label>
              <input value={header.address} readOnly />

              <label>Date</label>
              <input type="date" value={header.date}
                onChange={e => setHeader({ ...header, date: e.target.value })}
              />
            </div>

            <div className="rec-payment">
             <input
  ref={receivedRef}
  type="number"
  value={receivedAmount}
  onChange={e => {
    const v = Number(e.target.value || 0);
    setReceivedAmount(v);
    distributePayment(v);
  }}
  onKeyDown={e => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveBtnRef.current?.focus();   // 🔥 jump to SAVE
    }
  }}
  placeholder="Received Amount"
/>

            </div>

           <div className="rec-table-wrap">
  <table className="rec-table">
    <thead>
      <tr>
        <th>INV NO</th>
        <th>AMOUNT</th>
        <th>{balanceLabel}</th>
        <th>STATUS</th>
      </tr>
    </thead>
  </table>

  <div className="rec-table-body">
    <table className="rec-table">
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            <td>{r.invoiceNo}</td>

            <td>
              <input
                value={Number(r.amount ?? 0).toFixed(2)}
                readOnly
              />
            </td>

          <td>
  <input
    value={
      advance > 0 && Number(r.displayBalance ?? 0) === 0
        ? advance.toFixed(2)
        : Number(r.displayBalance ?? 0).toFixed(2)
    }
    readOnly
  />
</td>

            <td
              className={`status ${
                Number(r.displayBalance ?? 0) === 0
                  ? "paid"
                  : "pending"
              }`}
            >
              {Number(r.displayBalance ?? 0) === 0
                ? "PAID"
                : "PENDING"}
            </td>
          </tr>
        ))}

        {/* 🔥 Always show 3 rows minimum */}
        {rows.length < 3 &&
          Array.from({ length: 3 - rows.length }).map((_, i) => (
            <tr key={"empty-" + i}>
              <td></td>
              <td><input readOnly /></td>
              <td><input readOnly /></td>
              <td></td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>
</div>
<div className="rec-mobile-items">

{rows.map((r,i)=>(
<div key={i} className="rec-item-card">

<div className="item-row">
<label>Invoice</label>
<input value={r.invoiceNo} readOnly />
</div>

<div className="item-row">
<label>Amount</label>
<input value={Number(r.amount ?? 0).toFixed(2)} readOnly />
</div>

<div className="item-row">
<label>Balance</label>
<input value={Number(r.displayBalance ?? 0).toFixed(2)} readOnly />
</div>

<div className="item-row">
<label>Status</label>
<input
value={Number(r.displayBalance ?? 0) === 0 ? "PAID" : "PENDING"}
readOnly
/>
</div>

</div>
))}

</div>
            <div className="rec-summary-row">

  <div className="rec-summary-box">
    <label>Total</label>
    <input
      type="text"
      value={totalInvoice.toFixed(2)}
      readOnly
    />
  </div>

  <div className="rec-summary-box">
    <label>Recd</label>
    <input
      type="text"
      value={receivedAmount.toFixed(2)}
      readOnly
    />
  </div>

 <div className="rec-summary-box">
  <label>{balanceLabel}</label>
  <input
    type="text"
    value={balanceValue.toFixed(2)}
    readOnly
    className={advance > 0 ? "advance-box" : ""}
  />
  {balanceValue > 0 && !lessApplied && (
    <button
      className="less-btn"
      onClick={applyLess}
      title="Write off balance"
    >
      LESS
    </button>
  )}
  {lessApplied && (
    <span className="less-tag">-{discount.toFixed(2)} off</span>
  )}
</div>

</div>


            <div className="rec-payment">
             <input
value={payment.mode}
placeholder="Select Mode"
readOnly
onClick={()=>{
setPopup({
open:true,
field:"mode",
title:"Select Payment Mode",
options:["CASH","UPI","BANK","CHEQUE"],
allowAdd:false
});
}}
/>

              <input
                placeholder="Reference No"
                disabled={payment.mode === "CASH"}
                value={payment.ref}
                onChange={e => setPayment({ ...payment, ref: e.target.value })}
              />
            </div>

            <div className="rec-actions">
  <button
    ref={newBtnRef}
    onClick={resetForm}
    onKeyDown={e => handleActionKeys(e, "new")}
  >
    NEW
  </button>

  {!editReceiptId && (
    <button
      ref={saveBtnRef}
      className="primary"
      onClick={handleSave}
      onKeyDown={e => handleActionKeys(e, "save")}
    >
      SAVE
    </button>
  )}

  {editReceiptId && (
    <button
      ref={updateBtnRef}
      className="primary"
      onClick={handleUpdate}
      onKeyDown={e => handleActionKeys(e, "update")}
    >
      UPDATE
    </button>
  )}

  <button
    ref={exitBtnRef}
    onClick={goHome}
    onKeyDown={e => handleActionKeys(e, "exit")}
  >
    EXIT
  </button>
</div>
          </div>
        </div>

        {/* ================= RIGHT (RESTORED) ================= */}
        <div className="rec-right">
          <div className="rec-right-title">Receipt List</div>

          <input
            placeholder="Search party..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

 <div className="rec-list">
  {receiptList
    .filter(r =>
      r.partyName?.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) =>
      (a.partyName || "").localeCompare(b.partyName || "")
    )
    .map(r => (

      <div
        key={r.id}
        className="rec-list-row"
       onClick={()=>{
loadReceiptById(r.id);
if(window.innerWidth <= 768){
setMobileTab("entry");
}
}}
      >
        <div><b>REC {r.receiptNo}</b></div>
        <div>{r.partyName}</div>
        <div>₹ {r.totalReceived?.toFixed(2)}</div>
      </div>
    ))}
</div>


        </div>

      </div>
<button
className="mobile-add-btn"
onClick={()=>setMobileTab("entry")}
>
+
</button>
<div className="rec-mobile-bottom">

<button
className={mobileTab==="list"?"active":""}
onClick={()=>setMobileTab("list")}
>
Receipt List
</button>

<button
className={mobileTab==="entry"?"active":""}
onClick={()=>setMobileTab("entry")}
>
Entry
</button>

</div>
      {/* PARTY POPUP */}
      {showPartyPopup && (
  <div className="popup-overlay">
    <div className="popup-box" ref={popupRef}>
      <div className="popup-header">
        <span>Select Invoice Party</span>
        <button onClick={() => setShowPartyPopup(false)}>✕</button>
      </div>

      <input
        className="popup-search"
        autoFocus
        value={partySearch}
        onChange={e => setPartySearch(e.target.value)}
      />

 <div className="popup-list">
  {filteredParties.length === 0 && (
    <div className="popup-empty">
      No pending invoice parties
    </div>
  )}

  {filteredParties.map((p, i) => (
    <div
      key={i}
      className={`popup-row ${i === activeIndex ? "active" : ""}`}
      onClick={() => selectParty(p)}
    >
      {p}
    </div>
  ))}
</div>

    </div>
  </div>
)}
{popup.open && (

<SelectPopup
title={popup.title}
options={popup.options}
allowAdd={popup.allowAdd}

onSelect={(val)=>{
handlePopupSelect(val);
}}

onClose={()=>setPopup({...popup,open:false})}

/>

)}
            </div>
          

  
  );
}
